module.exports = __webpack_public_path__ + "img/avatar_cn_hover.e81ca0a0.png";